import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FloatingLiveChat = () => {
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    // Check for unread messages
    const checkUnread = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        
        // Use relative URL - works on any domain
        const response = await fetch('/api/messages/unread-count', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          setUnreadCount(data.unread_count);
        }
      } catch (error) {
        console.error('Error checking unread messages:', error);
      }
    };

    checkUnread();
    // Check every 10 seconds
    const interval = setInterval(checkUnread, 10000);
    
    return () => clearInterval(interval);
  }, []);

  const handleClick = () => {
    navigate('/live-chat');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-20 sm:bottom-6 right-4 sm:right-6 z-50 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-gradient-to-br from-purple-500 to-purple-600 hover:from-purple-400 hover:to-purple-500 shadow-2xl shadow-purple-500/50 flex items-center justify-center transition-all duration-300 hover:scale-110"
      aria-label="Live Chat Support"
      title="Chat with Support Team"
    >
      <MessageCircle className="w-7 h-7 sm:w-8 sm:h-8 text-white" />
      {unreadCount > 0 && (
        <>
          <span className="absolute -top-1 -right-1 w-5 h-5 sm:w-6 sm:h-6 bg-red-500 rounded-full border-2 border-white flex items-center justify-center">
            <span className="text-white text-xs font-bold">{unreadCount > 9 ? '9+' : unreadCount}</span>
          </span>
          <span className="absolute -top-1 -right-1 w-5 h-5 sm:w-6 sm:h-6 bg-red-500 rounded-full border-2 border-white animate-ping"></span>
        </>
      )}
    </button>
  );
};

export default FloatingLiveChat;
